// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.container[data-v-6536c93e] {\n  padding: 64px 80px;\n  text-align: left; /* 텍스트 및 인라인 요소 왼쪽 정렬 */\n  display: block;   /* Vuetify 기본 flex 속성 제거 */\n}\n.side-menu[data-v-6536c93e] {\n  border-right: 1px solid #d9d9d9;\n  padding: 64px 10px 0 10px;\n  text-align: left;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
